import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Benefits } from "@/components/Benefits";
import { Services } from "@/components/Services";
import { Cases } from "@/components/Cases";
import { Process } from "@/components/Process";
import { Pricing } from "@/components/Pricing";
import { About } from "@/components/About";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { Privatlivspolitik, Cookiepolitik } from "@/components/Legal";
import BarbershopCase from "@/components/cases/BarbershopCase";
import RenbyCase from "@/components/cases/RenbyCase";
import ApexAutoCase from "@/components/cases/ApexAutoCase";

const LandingPage = ({ onNavigate }) => (
  <div className="bg-white text-zinc-900 antialiased">
    <Navigation onNavigate={onNavigate} />
    <main>
      <Hero onNavigate={onNavigate} />
      <Marquee />
      <Benefits />
      <Services />
      <Cases />
      <Process />
      <Pricing onNavigate={onNavigate} />
      <About />
      <FinalCTA />
    </main>
    <Footer onNavigate={onNavigate} />
  </div>
);

export default function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    lenisRef.current?.scrollTo(id, { offset: -72, duration: 1.2 });
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage onNavigate={scrollTo} />} />
        <Route
          path="/cases/barbershop"
          element={<BarbershopCase onNavigate={scrollTo} />}
        />
        <Route path="/cases/renby" element={<RenbyCase onNavigate={scrollTo} />} />
        <Route path="/cases/apex-auto" element={<ApexAutoCase onNavigate={scrollTo} />} />
        <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
        <Route path="/cookiepolitik" element={<Cookiepolitik />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
